import { useEffect } from "react";

const InspectProtector = ({ children }) => {
  useEffect(() => {
    // Only apply protection in production
    if (process.env.NODE_ENV === "production") {
      // Prevent right-click context menu
      const handleContextMenu = (e) => {
        e.preventDefault();
        return false;
      };

      // Prevent keyboard shortcuts for developer tools
      const handleKeyDown = (e) => {
        if (
          e.key === "F12" ||
          (e.ctrlKey && e.shiftKey && e.key === "I") || // DevTools
          (e.ctrlKey && e.shiftKey && e.key === "J") || // DevTools Console
          (e.ctrlKey && e.key === "U") ||               // View Source
          (e.ctrlKey && e.shiftKey && e.key === "C")    // Inspect Element
        ) {
          e.preventDefault();
          return false;
        }
      };

      // Prevent drag and drop (optional)
      const handleDragStart = (e) => {
        e.preventDefault();
        return false;
      };

      // Add listeners
      document.addEventListener("contextmenu", handleContextMenu);
      document.addEventListener("keydown", handleKeyDown);
      document.addEventListener("dragstart", handleDragStart);

      // Cleanup
      return () => {
        document.removeEventListener("contextmenu", handleContextMenu);
        document.removeEventListener("keydown", handleKeyDown);
        document.removeEventListener("dragstart", handleDragStart);
      };
    }
  }, []);

  return <>{children}</>;
};

export default InspectProtector;
